export default __webpack_public_path__ + "static/media/CZ.09fce450.svg";